import { useSelector } from 'react-redux';

import { appliedFiltersSelector } from '@communicationManagement/selectors/blacklistLearnersFilter';
import { currentPageSelector } from '@communicationManagement/selectors/blacklistLearners';
import { useGetBlacklistsQuery } from '@communicationManagement/services/blacklistService';
import parseBlacklistLearnerRequest from '@communicationManagement/utils/parseBlacklistLearnerRequest';

export default function useFilteredBlacklistedLearners() {
  const appliedFilters = useSelector(appliedFiltersSelector);
  const currentPage = useSelector(currentPageSelector);

  const blacklistedLearnerParams = parseBlacklistLearnerRequest({
    currentPage,
    filters: appliedFilters,
  });

  const response = useGetBlacklistsQuery(blacklistedLearnerParams);

  return response;
}
